import { useTranslation } from '@common/hooks/translation';
import React, { useEffect, useState } from 'react';

const CrashError = () => {
  const t = useTranslation();
  const [timer, setTimer] = useState(20);

  const reload = () => window.jsobject?.reload() || window.location.reload();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (timer - 1 === 0) reload();
      else setTimer(timer - 1);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [timer]);

  return (
    <div className="crash-error-wrapper">
      {t('Unexpected error occured, Refreshing in {1} ...', timer)}
      <button type="button" onClick={() => reload()}>{t('Refresh')}</button>
      <span className="crash-error-terminal-detector">An Error Occurred</span>
    </div>
  );
};

export default CrashError;
